export default __webpack_public_path__ + "static/media/english-to-turkish-screenshot-02.36f35834.png";